export const ERROR_MINITOR = {
  yData: [
    '00:00',
    '01:00',
    '02:00',
    '03:00',
    '04:00',
    '05:00',
    '06:00',
    '07:00',
    '08:00',
    '09:00',
    '10:00',
    '11:00',
    '12:00',
    '13:00',
    '14:00',
    '15:00',
    '16:00',
    '17:00',
    '18:00',
    '19:00',
    '20:00',
    '21:00',
    '22:00',
    '23:00',
  ],
  xData: [-1],
};

export const EMPTY_MINITOR = {
  xData: [
    '01:00',
    '02:00',
    '03:00',
    '04:00',
    '05:00',
    '06:00',
    '07:00',
    '08:00',
    '09:00',
    '10:00',
    '11:00',
    '12:00',
    '13:00',
    '14:00',
    '15:00',
    '16:00',
    '17:00',
    '18:00',
    '19:00',
    '20:00',
    '21:00',
    '22:00',
    '23:00',
    '24:00',
  ],
  yData: [],
};

export const OFFLINE_STATUS = 0;

export const DEFAULT_TEXT = '--';

export const YAXIS_INFO = {
  online: { title: '时间(h)', standard: '' },
  pingLostAvg: { title: '丢包率(%)', standard: '建议低于2%' },
  pingRttAvg: { title: '时延(ms)', standard: '建议低于20ms' },
  nat: { title: 'NAT类型', standard: '建议全锥型及以上' },
  cpu: { title: '共享CPU(%)', standard: '建议90%以下' },
  mem: { title: '共享内存(%)', standard: '建议90%以下' },
};

export const INDICATOR_TITLE = {
  online: '今日在线情况',
  pingLostAvg: '今日线路平均丢包率',
  pingRttAvg: '今日线路平均时延',
  nat: '今日管理线路NAT',
  cpu: 'CPU占用率',
  mem: '内存占用率',
};

export const FS_TYPE = {
  lvm2_member: '裸盘',
  no_loop: '裸盘',
  ntfs: 'ntfs',
  fuseblk: 'ntfs',
  ufsd: 'ntfs',
  ext4: 'EXT4',
};

export const DISK_TYPE = {
  '3': 'U盘',
  '2': 'ssd',
  '1': 'hdd',
  '0': '未知',
};

export const DISK_ERROR = {
  '0': '设备离线，请检查电源等是否正常连接',
  '1': '在线',
  '2': '硬盘异常，请检查硬盘情况',
  '3': '未绑定设备',
  '4': '当前设备非网心云设备',
  '5': '设备升级中，约需几小时，请耐心等待',
  '6': 'IP异常',
  '7': '磁盘异常：硬盘无法使用，请更换硬盘后重试',
  '8': '磁盘异常，请查看',
  '9': '磁盘异常：未检测到硬盘，请确保已连接硬盘',
  '10': '磁盘异常：硬盘未格式化，请进行裸盘升级操作',
};

export const YAXIS_NAME = {
  onlineTime: '时间(h)',
  nat: 'NAT类型',
  pingLostAvg: '丢包率(%)',
  pingRttAvg: '时延(ms)',
  cpu: 'CPU占用率(%)',
  mem: '内存占用率(%)',
};

export const OPTIMIZE_INFO = {
  online: {
    1: {
      suggest: '您晚高峰（18:00-24:00)不在线，请务必保持晚高峰在线才有收益。',
      linkText: '去优化',
      link: 'https://help.yfanqie.com/c165/5a0c',
    },
  },
  pingLostAvg: {
    1: {
      suggest: '您当前的丢包率过高可能会影响收益。',
      linkText: '去优化',
      link: 'https://help.yfanqie.com/c165/805b',
    },
    2: {
      suggest: '您当前的丢包率较高可能会影响收益。',
      linkText: '去优化',
      link: 'https://help.yfanqie.com/c165/805b',
    },
  },
  pingRttAvg: {
    1: {
      suggest: '您当前的时延较高可能会影响收益。',
      linkText: '去优化',
      link: 'https://help.yfanqie.com/c165/7efc',
    },
    2: {
      suggest: '您当前的时延过高可能会影响收益。',
      linkText: '去优化',
      link: 'https://help.yfanqie.com/c165/7efc',
    },
  },
  nat: {
    1: {
      suggest: '您当前的nat类型差可能会影响收益，建议优化为公网型。',
      linkText: '去优化',
      link: 'https://help.yfanqie.com/c165/6d1e',
    },
    2: {
      suggest: '您当前的nat类型差可能会影响收益，建议优化为公网型。',
      linkText: '去优化',
      link: 'https://help.yfanqie.com/c165/6d1e',
    },
  },
  cpu: {
    1: {
      suggest: '您当前的cpu占用率过高，推荐使用SSD有助于收益。',
      linkText: '推荐配置',
      link: 'https://help.yfanqie.com/c165/a29e',
    },
  },
  mem: {
    1: {
      suggest: '您当前的内存占用率过高，建议更换配置有助于收益。',
      linkText: '推荐配置',
      link: 'https://help.yfanqie.com/c165/89d1',
    },
  },
  disk: {
    0: {},
    7: {
      suggest: '您的磁盘无法使用，请更换磁盘，推荐480G SSD。',
      linkText: '详细攻略',
      link: 'https://help.yfanqie.com/c165/6476',
    },
    8: {
      suggest: '您的磁盘异常，请尝试重启->格式化->更换480G SSD排查原因。',
      linkText: '详细攻略',
      link: 'https://help.yfanqie.com/c165/6476',
    },
    9: {
      suggest: '未识别到磁盘，请连接磁盘并确保易驱线正常，建议480g SSD。',
      linkText: '详细攻略',
      link: 'https://help.yfanqie.com/c165/c995',
    },
    10: {
      suggest: '您的磁盘未格式化将无收益，请先格式化硬盘。',
      linkText: '去申请',
      link: 'https://help.yfanqie.com/c165/6476',
    },
    11: {
      suggest: '当前业务无需安装硬盘，请继续保持设备在线。',
      linkText: '',
      link: '',
    },
  },
};

export const COUNTER_NUM_TYPE = ['mediumCount', 'poorCount', 'vpoorCount'];

export const CHART_INFO = {
  pingLostAvg: {
    title: '线路丢包率',
    mainType: 'networkQuality',
    link: 'https://help.yfanqie.com/c165/bcd3', // 查看攻略链接
    scale: [
      { level: '极差', tag: null, lineName: 'vpoorCount' },
      { level: '较差', tag: '20%', lineName: 'poorCount' },
      { level: '中等', tag: '10%', lineName: 'mediumCount' },
      { level: '良好', tag: '5%', lineName: 'goodCount' },
      { level: '优秀', tag: '2%', lineName: 'vgoodCount' },
    ],
    chartTitle: '今日线路丢包率',
    standard: '建议低于2%',
    lineQueryCode: 1,
    lineIndicatorName: '丢包',
  },
  pingRttAvg: {
    mainType: 'networkQuality',
    title: '线路时延',
    link: 'https://help.yfanqie.com/c165/bcd3', // 查看攻略链接
    scale: [
      { level: '极差', tag: null, lineName: 'vpoorCount' },
      { level: '较差', tag: '200ms', lineName: 'poorCount' },
      { level: '中等', tag: '100ms', lineName: 'mediumCount' },
      { level: '良好', tag: '50ms', lineName: 'goodCount' },
      { level: '优秀', tag: '20ms', lineName: 'vgoodCount' },
    ],
    chartTitle: '今日线路时延',
    standard: '建议低于20ms',
    lineQueryCode: 2,
    lineIndicatorName: '时延',
  },
  nat: {
    title: '线路NAT',
    mainType: 'nat',
    link: 'https://help.yfanqie.com/3b0d/4ff0', // 查看攻略链接
    scale: [
      { level: '极差', tag: '对称', lineName: 'vpoorCount' },
      { level: '较差', tag: '端口', lineName: 'poorCount' },
      { level: '中等', tag: 'IP', lineName: 'mediumCount' },
      { level: '良好', tag: '全锥', lineName: 'goodCount' },
      { level: '优秀', tag: '映射DMZ', lineName: 'vgoodCount' },
      { level: '卓越', tag: '公网', lineName: 'excellentCount' },
    ],
    chartTitle: '今日线路NAT',
    standard: '建议全锥型及以上',
    lineQueryCode: 3,
    lineIndicatorName: 'NAT',
  },
};

export const NAT_LEVEL_TEXT = {
  '-1': '异常',
  0: '未知',
  1: '卓越',
  2: '良好',
  3: '中等',
  4: '较差',
  5: '极差',
  6: '优秀',
  7: '优秀',
};

export const LEVEL_TEXT = {
  null: '未知',
  0: '未知',
  1: '优秀',
  2: '良好',
  3: '中等',
  4: '较差',
  5: '极差',
  6: '卓越',
};
